import React, { memo, useCallback, useEffect, useState } from 'react'
import apiClient from '../../../utils/api/apiClient'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import { formatedDate } from '../../../utils/formatedDate'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { PenIcon } from '../../Icons/PenIcon'
import { Spinner, Alert } from 'react-bootstrap'
import { makeCall } from "../../../utils/api/makeCall";
import { useCancelToken } from "../../../utils/hooks/useCancelToken";

const AssetData = memo(({ selectedRow, handleCloseOverlayRight }) => {
    const { t } = useTranslation()
    const [assetInfo, setAssetInfo] = useState(null)
    const [error, setError] = useState({})
    const [loading, setLoading] = useState({})
    const { createOrCancelToken, sourceRef, isCancel } = useCancelToken();

    const getAssetInfo = useCallback(() => {
        createOrCancelToken();
        makeCall('getInfo', async () => {
            let data = await apiClient.getJson(APIEndpoints.assets(selectedRow.id).info, null, true, false, true, { cancelToken: sourceRef.current.token })
            setAssetInfo(data);
        }, setError, setLoading, isCancel)
    }, [createOrCancelToken, isCancel, selectedRow.id, sourceRef])

    useEffect(() => {
        if (selectedRow) {
            setAssetInfo(null);
            getAssetInfo()
        }
        return () => { setError('') }
    }, [getAssetInfo, selectedRow])



    const assetDataArray = assetInfo && [
        {
            label: `${t('assetOverlay:number')}:`,
            value: assetInfo.number
        },
        {
            label: `${t('assetOverlay:number2')}:`,
            value: assetInfo.number2 || '-'
        },
        {
            label: `${t('assetOverlay:company')}:`,
            value: assetInfo.mandator.displayName
        },
        !!assetInfo.group &&
        {
            label: `${t('assetOverlay:group')}:`,
            value: assetInfo.group.displayName
        },
        {
            label: `${t('assetOverlay:type')}:`,
            value: assetInfo.type ? assetInfo.type.displayName : '-'
        },
        {
            label: `${t('assetOverlay:organisationUnit')}:`,
            value: assetInfo.office ? assetInfo.office.displayName : '-'
        },
        {
            label: `${t('assetOverlay:costCenter')}:`,
            value: assetInfo.costCenter ? assetInfo.costCenter.displayName : '-'
        },
        !!assetInfo.responisble &&
        {
            label: `${t('assetOverlay:responsible')}:`,
            value: assetInfo.responisble.displayName
        },
        {
            label: `${t('assetOverlay:jobFunction')}:`,
            value: (assetInfo.activities.map(item => <div key={item.id}>{item.displayName}</div>)) || '-'
        },
        formatedDate(assetInfo.deactivationDate)
            ? {
                label: `${t('assetOverlay:inactiveSince')}:`,
                value: formatedDate(assetInfo.deactivationDate)
            }
            : {
                label: `${t('assetOverlay:activeSince')}:`,
                value: formatedDate(assetInfo.activationDate) ? formatedDate(assetInfo.activationDate) : '-'
            }
    ]

    if (loading.getInfo) {
        return (
            <div className="d-flex align-items-center justify-content-center">
                <Spinner animation='border' variant='primary' />
            </div>
        )
    }
    return (
        <>
            <span className="data-list__name h2">
                {selectedRow.displayName}
                <Link to={`/editasset/${selectedRow.id}`}>
                    <PenIcon onClick={handleCloseOverlayRight} className="edit-button" />
                </Link>
            </span>
            {error.getInfo && <Alert variant="danger">{error.getInfo.value}</Alert>}
            {assetInfo === null
                ? <div className="d-flex align-items-center justify-content-center">
                    <Spinner animation='border' variant='primary' />
                </div>
                : <ul className="data-list__data">
                    {assetDataArray.map((listItem, idx) => {
                        return (
                            <li key={`${idx} ${listItem.label}`} className='data-list__entry'>
                                <div className="data-list__label">{listItem.label}</div>
                                <div className="data-list__value">{listItem.value}</div>
                            </li>
                        )
                    })}
                </ul>
            }
        </>
    )
});

export default AssetData;
